import { render, staticRenderFns } from "./MemoSets.vue?vue&type=template&id=3a2c0792&scoped=true"
import script from "./MemoSets.vue?vue&type=script&lang=js"
export * from "./MemoSets.vue?vue&type=script&lang=js"
import style0 from "./MemoSets.vue?vue&type=style&index=0&id=3a2c0792&prod&lang=css"
import style1 from "./MemoSets.vue?vue&type=style&index=1&id=3a2c0792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c0792",
  null
  
)

export default component.exports